function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { registerAction, unregisterAction } from 'helpers/reducerTools';
import { SET_NEW_CONFIGURATION_VERSION } from 'modules/App/actionTypes';
import * as actionTypes from './actionTypes';
const initialState = {
    organizationMemberships: [],
    clinicMemberships: [],
    clinicCustomIdentifiers: [],
    clinicCustomIdentifiersCountryId: null,
    patientsCount: null,
    importPatientDatabaseProgress: 0,
    importPatientDatabaseSuccessCount: 0,
    importPatientDatabaseErrorCount: 0,
    importPatientDatabaseErrorsList: [],
    importPatientDatabaseIsWorking: false,
    fetching: [],
    sending: [],
    errors: [],
    countrySettings: null,
    clinicSettings: null
};
export default function reducer(state = _object_spread({}, initialState), action = {}) {
    switch(action.type){
        case actionTypes.FETCH_CLINIC_CUSTOM_IDENTIFIERS:
            {
                return _object_spread_props(_object_spread({}, state), {
                    fetching: registerAction(state.fetching, actionTypes.FETCH_CLINIC_CUSTOM_IDENTIFIERS),
                    errors: unregisterAction(state.errors, actionTypes.FETCH_CLINIC_CUSTOM_IDENTIFIERS)
                });
            }
        case actionTypes.FETCH_CLINIC_CUSTOM_IDENTIFIERS_SUCCESS:
            {
                const { clinicCustomIdentifiersCountryId, clinicCustomIdentifiers } = action.payload;
                if (clinicCustomIdentifiersCountryId === state.clinicCustomIdentifiersCountryId) {
                    return _object_spread_props(_object_spread({}, state), {
                        fetching: unregisterAction(state.fetching, actionTypes.FETCH_CLINIC_CUSTOM_IDENTIFIERS)
                    });
                }
                return _object_spread_props(_object_spread({}, state), {
                    clinicCustomIdentifiers,
                    clinicCustomIdentifiersCountryId,
                    fetching: unregisterAction(state.fetching, actionTypes.FETCH_CLINIC_CUSTOM_IDENTIFIERS)
                });
            }
        case actionTypes.FETCH_CLINIC_CUSTOM_IDENTIFIERS_ERROR:
            {
                return _object_spread_props(_object_spread({}, state), {
                    fetching: unregisterAction(state.fetching, actionTypes.FETCH_CLINIC_CUSTOM_IDENTIFIERS),
                    errors: registerAction(state.errors, actionTypes.FETCH_CLINIC_CUSTOM_IDENTIFIERS)
                });
            }
        //------------------------------------------------------------------------------------------------------------------
        case actionTypes.STORE_CLINIC:
            {
                return _object_spread_props(_object_spread({}, state), {
                    sending: registerAction(state.sending, actionTypes.STORE_CLINIC),
                    errors: unregisterAction(state.errors, actionTypes.STORE_CLINIC)
                });
            }
        case actionTypes.STORE_CLINIC_SUCCESS:
            {
                return _object_spread_props(_object_spread({}, state), {
                    sending: unregisterAction(state.sending, actionTypes.STORE_CLINIC)
                });
            }
        case actionTypes.STORE_CLINIC_ERROR:
            {
                return _object_spread_props(_object_spread({}, state), {
                    sending: unregisterAction(state.sending, actionTypes.STORE_CLINIC),
                    errors: registerAction(state.errors, actionTypes.STORE_CLINIC)
                });
            }
        //------------------------------------------------------------------------------------------------------------------
        case actionTypes.GET_STORED_CLINIC:
            {
                return _object_spread_props(_object_spread({}, state), {
                    sending: registerAction(state.sending, actionTypes.GET_STORED_CLINIC),
                    errors: unregisterAction(state.errors, actionTypes.GET_STORED_CLINIC)
                });
            }
        case actionTypes.GET_STORED_CLINIC_SUCCESS:
            {
                return _object_spread_props(_object_spread({}, state), {
                    sending: unregisterAction(state.sending, actionTypes.GET_STORED_CLINIC)
                });
            }
        case actionTypes.GET_STORED_CLINIC_ERROR:
            {
                return _object_spread_props(_object_spread({}, state), {
                    sending: unregisterAction(state.sending, actionTypes.GET_STORED_CLINIC),
                    errors: registerAction(state.errors, actionTypes.GET_STORED_CLINIC)
                });
            }
        //------------------------------------------------------------------------------------------------------------------
        case actionTypes.SET_CLINIC_CLOUD_DRIVE:
            {
                return _object_spread_props(_object_spread({}, state), {
                    sending: registerAction(state.sending, actionTypes.SET_CLINIC_CLOUD_DRIVE),
                    errors: unregisterAction(state.errors, actionTypes.SET_CLINIC_CLOUD_DRIVE)
                });
            }
        case actionTypes.SET_CLINIC_CLOUD_DRIVE_SUCCESS:
            {
                return _object_spread_props(_object_spread({}, state), {
                    sending: unregisterAction(state.sending, actionTypes.SET_CLINIC_CLOUD_DRIVE)
                });
            }
        case actionTypes.SET_CLINIC_CLOUD_DRIVE_ERROR:
            {
                return _object_spread_props(_object_spread({}, state), {
                    sending: unregisterAction(state.sending, actionTypes.SET_CLINIC_CLOUD_DRIVE),
                    errors: registerAction(state.errors, actionTypes.SET_CLINIC_CLOUD_DRIVE)
                });
            }
        //------------------------------------------------------------------------------------------------------------------
        case actionTypes.UPDATE_CLINIC_GLUCOSE_SETTINGS:
            {
                return _object_spread_props(_object_spread({}, state), {
                    sending: registerAction(state.sending, actionTypes.UPDATE_CLINIC_GLUCOSE_SETTINGS),
                    errors: unregisterAction(state.errors, actionTypes.UPDATE_CLINIC_GLUCOSE_SETTINGS)
                });
            }
        case actionTypes.UPDATE_CLINIC_GLUCOSE_SETTINGS_SUCCESS:
            {
                return _object_spread_props(_object_spread({}, state), {
                    sending: unregisterAction(state.sending, actionTypes.UPDATE_CLINIC_GLUCOSE_SETTINGS)
                });
            }
        case actionTypes.UPDATE_CLINIC_GLUCOSE_SETTINGS_ERROR:
            {
                return _object_spread_props(_object_spread({}, state), {
                    sending: unregisterAction(state.sending, actionTypes.UPDATE_CLINIC_GLUCOSE_SETTINGS),
                    errors: registerAction(state.errors, actionTypes.UPDATE_CLINIC_GLUCOSE_SETTINGS)
                });
            }
        //------------------------------------------------------------------------------------------------------------------
        case actionTypes.UPDATE_CLINIC_KPI_SETTINGS:
            {
                return _object_spread_props(_object_spread({}, state), {
                    sending: registerAction(state.sending, actionTypes.UPDATE_CLINIC_KPI_SETTINGS),
                    errors: unregisterAction(state.errors, actionTypes.UPDATE_CLINIC_KPI_SETTINGS)
                });
            }
        case actionTypes.UPDATE_CLINIC_KPI_SETTINGS_SUCCESS:
            {
                return _object_spread_props(_object_spread({}, state), {
                    sending: unregisterAction(state.sending, actionTypes.UPDATE_CLINIC_KPI_SETTINGS)
                });
            }
        case actionTypes.UPDATE_CLINIC_KPI_SETTINGS_ERROR:
            {
                return _object_spread_props(_object_spread({}, state), {
                    sending: unregisterAction(state.sending, actionTypes.UPDATE_CLINIC_KPI_SETTINGS),
                    errors: registerAction(state.errors, actionTypes.UPDATE_CLINIC_KPI_SETTINGS)
                });
            }
        //------------------------------------------------------------------------------------------------------------------
        case actionTypes.REAUTHORIZE_CLINIC_CLOUD_DRIVE:
            {
                return _object_spread_props(_object_spread({}, state), {
                    sending: registerAction(state.sending, actionTypes.REAUTHORIZE_CLINIC_CLOUD_DRIVE),
                    errors: unregisterAction(state.errors, actionTypes.REAUTHORIZE_CLINIC_CLOUD_DRIVE)
                });
            }
        case actionTypes.REAUTHORIZE_CLINIC_CLOUD_DRIVE_SUCCESS:
            {
                return _object_spread_props(_object_spread({}, state), {
                    sending: unregisterAction(state.sending, actionTypes.REAUTHORIZE_CLINIC_CLOUD_DRIVE)
                });
            }
        case actionTypes.REAUTHORIZE_CLINIC_CLOUD_DRIVE_ERROR:
            {
                return _object_spread_props(_object_spread({}, state), {
                    sending: unregisterAction(state.sending, actionTypes.REAUTHORIZE_CLINIC_CLOUD_DRIVE),
                    errors: registerAction(state.errors, actionTypes.REAUTHORIZE_CLINIC_CLOUD_DRIVE)
                });
            }
        //------------------------------------------------------------------------------------------------------------------
        case actionTypes.FETCH_ORGANIZATION_MEMBERSHIPS:
            {
                return _object_spread_props(_object_spread({}, state), {
                    fetching: registerAction(state.fetching, actionTypes.FETCH_ORGANIZATION_MEMBERSHIPS),
                    errors: unregisterAction(state.errors, actionTypes.FETCH_ORGANIZATION_MEMBERSHIPS)
                });
            }
        case actionTypes.FETCH_ORGANIZATION_MEMBERSHIPS_SUCCESS:
            {
                const { organizationMemberships } = action.payload;
                return _object_spread_props(_object_spread({}, state), {
                    organizationMemberships,
                    fetching: unregisterAction(state.fetching, actionTypes.FETCH_ORGANIZATION_MEMBERSHIPS)
                });
            }
        case actionTypes.FETCH_ORGANIZATION_MEMBERSHIPS_ERROR:
            {
                return _object_spread_props(_object_spread({}, state), {
                    fetching: unregisterAction(state.fetching, actionTypes.FETCH_ORGANIZATION_MEMBERSHIPS),
                    errors: registerAction(state.errors, actionTypes.FETCH_ORGANIZATION_MEMBERSHIPS)
                });
            }
        //------------------------------------------------------------------------------------------------------------------
        case actionTypes.FETCH_CLINIC_MEMBERSHIPS:
            {
                return _object_spread_props(_object_spread({}, state), {
                    fetching: registerAction(state.fetching, actionTypes.FETCH_CLINIC_MEMBERSHIPS),
                    errors: unregisterAction(state.errors, actionTypes.FETCH_CLINIC_MEMBERSHIPS)
                });
            }
        case actionTypes.FETCH_CLINIC_MEMBERSHIPS_SUCCESS:
            {
                const { clinicMemberships } = action.payload;
                return _object_spread_props(_object_spread({}, state), {
                    clinicMemberships,
                    fetching: unregisterAction(state.fetching, actionTypes.FETCH_CLINIC_MEMBERSHIPS)
                });
            }
        case actionTypes.FETCH_CLINIC_MEMBERSHIPS_ERROR:
            {
                return _object_spread_props(_object_spread({}, state), {
                    fetching: unregisterAction(state.fetching, actionTypes.FETCH_CLINIC_MEMBERSHIPS),
                    errors: registerAction(state.errors, actionTypes.FETCH_CLINIC_MEMBERSHIPS)
                });
            }
        //------------------------------------------------------------------------------------------------------------------
        case actionTypes.SET_PATIENTS_COUNT:
            {
                const { patientsCount } = action.payload;
                return _object_spread_props(_object_spread({}, state), {
                    patientsCount
                });
            }
        //------------------------------------------------------------------------------------------------------------------
        case actionTypes.REMOVE_CLINIC_DATA:
            {
                return _object_spread_props(_object_spread({}, state), {
                    sending: registerAction(state.sending, actionTypes.REMOVE_CLINIC_DATA),
                    errors: unregisterAction(state.errors, actionTypes.REMOVE_CLINIC_DATA)
                });
            }
        case actionTypes.REMOVE_CLINIC_DATA_SUCCESS:
            {
                return _object_spread_props(_object_spread({}, state), {
                    sending: unregisterAction(state.sending, actionTypes.REMOVE_CLINIC_DATA)
                });
            }
        case actionTypes.REMOVE_CLINIC_DATA_ERROR:
            {
                return _object_spread_props(_object_spread({}, state), {
                    sending: unregisterAction(state.sending, actionTypes.REMOVE_CLINIC_DATA),
                    errors: registerAction(state.errors, actionTypes.REMOVE_CLINIC_DATA)
                });
            }
        //------------------------------------------------------------------------------------------------------------------
        case actionTypes.IMPORT_PATIENT_DATABASE:
            {
                const { isCheckOnly } = action.payload;
                return _object_spread_props(_object_spread({}, state), {
                    // importPatientDatabaseProgress : 0,
                    importPatientDatabaseIsWorking: !isCheckOnly,
                    sending: registerAction(state.sending, actionTypes.IMPORT_PATIENT_DATABASE)
                });
            }
        case actionTypes.IMPORT_PATIENT_DATABASE_PATIENT_STORED:
            {
                const { successCount, errorCount, errorsList } = action.payload;
                return _object_spread_props(_object_spread({}, state), {
                    importPatientDatabaseSuccessCount: successCount,
                    importPatientDatabaseErrorCount: errorCount,
                    importPatientDatabaseErrorsList: errorsList
                });
            }
        case actionTypes.IMPORT_PATIENT_DATABASE_SUCCESS:
            {
                const { progress } = action.payload;
                return _object_spread_props(_object_spread({}, state), {
                    importPatientDatabaseProgress: progress
                });
            }
        case actionTypes.IMPORT_PATIENT_DATABASE_END:
        case actionTypes.IMPORT_PATIENT_DATABASE_ERROR:
            {
                const { noReset } = action.payload || {};
                if (noReset) {
                    return _object_spread_props(_object_spread({}, state), {
                        importPatientDatabaseIsWorking: false,
                        sending: unregisterAction(state.sending, actionTypes.IMPORT_PATIENT_DATABASE)
                    });
                }
                return _object_spread_props(_object_spread({}, state), {
                    importPatientDatabaseProgress: 0,
                    importPatientDatabaseSuccessCount: 0,
                    importPatientDatabaseErrorCount: 0,
                    importPatientDatabaseErrorsList: [],
                    importPatientDatabaseIsWorking: false,
                    sending: unregisterAction(state.sending, actionTypes.IMPORT_PATIENT_DATABASE)
                });
            }
        //------------------------------------------------------------------------------------------------------------------
        case actionTypes.SET_CLINIC_LICENCE:
            {
                return _object_spread_props(_object_spread({}, state), {
                    fetching: registerAction(state.fetching, actionTypes.SET_CLINIC_LICENCE),
                    errors: unregisterAction(state.errors, actionTypes.SET_CLINIC_LICENCE)
                });
            }
        case actionTypes.SET_CLINIC_LICENCE_SUCCESS:
            {
                return _object_spread_props(_object_spread({}, state), {
                    fetching: unregisterAction(state.fetching, actionTypes.SET_CLINIC_LICENCE)
                });
            }
        case actionTypes.SET_CLINIC_LICENCE_ERROR:
            {
                return _object_spread_props(_object_spread({}, state), {
                    fetching: unregisterAction(state.fetching, actionTypes.SET_CLINIC_LICENCE),
                    errors: registerAction(state.errors, actionTypes.SET_CLINIC_LICENCE)
                });
            }
        //------------------------------------------------------------------------------------------------------------------
        case actionTypes.FETCH_CLINIC_COUNTRY_SETTINGS:
            {
                return _object_spread_props(_object_spread({}, state), {
                    fetching: registerAction(state.fetching, actionTypes.FETCH_CLINIC_COUNTRY_SETTINGS),
                    errors: unregisterAction(state.errors, actionTypes.FETCH_CLINIC_COUNTRY_SETTINGS)
                });
            }
        case actionTypes.FETCH_CLINIC_COUNTRY_SETTINGS_SUCCESS:
            {
                const { countrySettings } = action.payload;
                return _object_spread_props(_object_spread({}, state), {
                    countrySettings,
                    fetching: unregisterAction(state.fetching, actionTypes.FETCH_CLINIC_COUNTRY_SETTINGS)
                });
            }
        case actionTypes.FETCH_CLINIC_COUNTRY_SETTINGS_ERROR:
            {
                return _object_spread_props(_object_spread({}, state), {
                    fetching: unregisterAction(state.fetching, actionTypes.FETCH_CLINIC_COUNTRY_SETTINGS),
                    errors: registerAction(state.errors, actionTypes.FETCH_CLINIC_COUNTRY_SETTINGS)
                });
            }
        //------------------------------------------------------------------------------------------------------------------
        case actionTypes.FETCH_CLINIC_SETTINGS:
            {
                return _object_spread_props(_object_spread({}, state), {
                    fetching: registerAction(state.fetching, actionTypes.FETCH_CLINIC_SETTINGS),
                    errors: unregisterAction(state.errors, actionTypes.FETCH_CLINIC_SETTINGS)
                });
            }
        case actionTypes.FETCH_CLINIC_SETTINGS_SUCCESS:
            {
                const { clinicSettings } = action.payload;
                return _object_spread_props(_object_spread({}, state), {
                    clinicSettings,
                    fetching: unregisterAction(state.fetching, actionTypes.FETCH_CLINIC_SETTINGS)
                });
            }
        case actionTypes.FETCH_CLINIC_SETTINGS_ERROR:
            {
                return _object_spread_props(_object_spread({}, state), {
                    fetching: unregisterAction(state.fetching, actionTypes.FETCH_CLINIC_SETTINGS),
                    errors: registerAction(state.errors, actionTypes.FETCH_CLINIC_SETTINGS)
                });
            }
        // BackOffice UPDATE -----------------------------------------------------------------------------------------------
        case SET_NEW_CONFIGURATION_VERSION:
            {
                const { countrySettings } = action.payload;
                return _object_spread_props(_object_spread({}, state), {
                    countrySettings
                });
            }
        //------------------------------------------------------------------------------------------------------------------
        default:
            {
                return state;
            }
    }
}
